<template>
  <WdsText :text="isValid ? date : '-'" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const HireLastPaymentRequestColumn = graphql(`
  fragment HireLastPaymentRequestColumn on Hire {
    id
    lastPaymentRequestDate
  }
`)

const props = defineProps<{ row: FragmentType<typeof HireLastPaymentRequestColumn> }>()
const column = computed(() => useFragment(HireLastPaymentRequestColumn, props.row))
const { date, isValid } = useDate(column.value.lastPaymentRequestDate, 'YYYY-MM-DD')
</script>
